import { createClient } from '@supabase/supabase-js';

export const supabase = createClient('https://injopiundklckuoajznz.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imluam9waXVuZGtsY2t1b2Fqem56Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg0NjE3MDIsImV4cCI6MjA1NDAzNzcwMn0.Z15sBIv71g3RRycjgzj6SjkC6FlyuAxLh4UPtdJhZ_E');
